/**
 * Web consumes these directly as MUI breakpoint `values` (px). RN has no viewport breakpoints,
 * but layouts that need to branch on screen width (e.g. Candidate persona master-detail vs.
 * stacked) can compare `Dimensions.get('window').width` against these same numbers so both
 * platforms agree on where "mobile" ends and "tablet/desktop" begins.
 */
export const breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1280,
  wide: 1536,
} as const;

/** MUI-shaped alias (xs/sm/md/lg/xl) — same numbers, MUI's own breakpoint-key vocabulary. */
export const breakpointsMui = {
  xs: breakpoints.mobile,
  sm: 360,
  md: breakpoints.tablet,
  lg: breakpoints.desktop,
  xl: breakpoints.wide,
} as const;

export type BreakpointKey = keyof typeof breakpoints;
